import React from 'react'
import { Route } from 'react-router-dom'
import { SigninMethodList } from './page/signin-method-list'
import { SigninMethodScreen } from './page/signin-method-screen'

// Sign-in methods: the list (the sidebar's and the SSO tabs' entry) and one
// method's screen, named by its kind (microsoft, google, apple, facebook).
export const LayoutSigninMethod = () => {
  return (
    <React.Fragment>
      <Route path="/admin/signin-method" exact component={SigninMethodList} />
      <Route path="/admin/signin-methods/:kind" component={SigninMethodScreen} />
    </React.Fragment>
  )
}
